import React from 'react';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, cardVariant, popIn, drawLine } from '../../components/functions/animation';
import { experiences } from '../../data/experience';
import './Experience.css';

const Experience = () => (
  <div id="experience">
    <div className="container">
      <motion.div variants={fadeInUp} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }}>
        <p className="section-label">Career</p>
        <h2 className="heading">Work <span>Experience</span></h2>
      </motion.div>

      <motion.div
        className="exp-timeline"
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
      >
        {experiences.map((exp, i) => (
          <motion.div className="exp-card" key={i} custom={i} variants={cardVariant} whileHover={{ x: 4, y: -5, boxShadow: '0 12px 36px rgba(0,0,0,0.4)' }} transition={{ type: 'spring', stiffness: 260, damping: 22 }}>
            {/* Left – logo + vertical line */}
            <div className="exp-logo-col">
              <motion.div className="exp-logo-wrap" variants={popIn}>
                {exp.logo
                  ? <img src={exp.logo} alt={exp.logoAlt} />
                  : <span className="exp-logo-fallback">{exp.logoFallback}</span>
                }
              </motion.div>
              {i < experiences.length - 1 && (
                <motion.div
                  className="exp-line"
                  variants={drawLine}
                />
              )}
            </div>

            {/* Right – content */}
            <div className="exp-content">
              <div className="exp-header">
                <div>
                  <h3 className="exp-role">{exp.role}</h3>
                  <p className="exp-company">{exp.company}</p>
                </div>
                <span className="exp-duration">{exp.duration}</span>
              </div>
              <ul className="exp-bullets">
                {exp.bullets.map((b, j) => <li key={j}>{b}</li>)}
              </ul>
              {exp.tech && (
                <div className="exp-tech-tags">
                  {exp.tech.map((t, k) => <span key={k} className="exp-tech-tag">{t}</span>)}
                </div>
              )}
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </div>
);

export default Experience;
